import { ChatProviderType } from '../../../domain/chat/models/ChatProviderType';
import { ChatSession } from '../../../domain/chat/models/ChatSession';
import { SendChatMessageRequest } from '../../../services/chat/interfaces/IChatMessagesService';
import { SendChatMessageCommand } from '../models/SendChatMessageCommand';

export const mapSendChatMessageCommandToProviderRequest = (
	command: SendChatMessageCommand,
	session: ChatSession,
): SendChatMessageRequest => {

	if (session.providerType === ChatProviderType.ProGPT) {
		return {
			providerType: ChatProviderType.ProGPT,
			chatId: command.chatId,
			input: command.input,
			images: command.images,
			thinkLonger: command.thinkLonger,
			selectedAgents: command.selectedAgents,
			regenerate: command.regenerate,
		};

	}

	if (session.providerType === ChatProviderType.Nexus) {
		return {
			providerType: ChatProviderType.Nexus,
			chatId: command.chatId,
			input: command.input,
			images: command.images,
			agentId: session.agentId,
		};
	}

	throw new Error(`sendMessage not supported for provider type: ${session.providerType}`);
};

export default mapSendChatMessageCommandToProviderRequest;

